import { z } from 'zod';

export const CandidateAiSearchSchema = z.object({
  aiSearchText: z.string().min(1, { message: 'Required' }),
});

export type CandidateAiSearchType = z.infer<typeof CandidateAiSearchSchema>;
